<main>
  <div>
    <app-menu></app-menu>
    <aside *ngIf="!event && loadingEvent === false" aria-label="event-not-found">
      <header>
        <div>
          <h1>evenement niet gevonden</h1>
        </div>
      </header>
      <section>
        <div>
          <h2>Oeps, het evenement die je probeert te openen bestaat niet.</h2>
        </div>
        <div>
          <app-button *ngIf="itemType === itemTypeEnum.Trainingen" class="filled-primary" routerLink="..">Terug naar de training</app-button>
          <app-button *ngIf="itemType === itemTypeEnum.KennisCafe" class="filled-primary" routerLink="..">Terug naar het kenniscafé</app-button>
        </div>
      </section>
    </aside>
    <aside *ngIf="event && loadingEvent === false" aria-label="event-found">
      <header>
        <img *ngIf="itemType === itemTypeEnum.Trainingen" src="/assets/images/banner-rensa-training.jpg" alt="Rensa training banner"/>
        <img *ngIf="itemType === itemTypeEnum.KennisCafe" src="/assets/images/banner-rensa-kenniscafe.png" alt="Rensa kenniscafé banner"/>
        <div>
          <h1>Aanmelden</h1>
        </div>
      </header>
      <section>
        <div class="gray-container">
          <div class="normal-text" *ngIf="!event.startDateTime">Er is nog geen datum en tijd bekend voor dit evenement. Je kan je dus nog niet aanmelden voor:</div>
          <div class="normal-text" *ngIf="event.startDateTime && itemType === itemTypeEnum.Trainingen">Je meldt je aan voor de training:</div>
          <div class="normal-text" *ngIf="event.startDateTime && itemType === itemTypeEnum.KennisCafe">Je meldt je aan voor het kenniscafé:</div>
          <h2>‘{{item?.title}}’</h2>
          <div class="normal-text" *ngIf="event.startDateTime">
            op <span class="info">{{(event?.startDateTime * 1000) | date: 'dd/MM/yyyy'}}</span> in <span class="info">{{event?.location?.city}}</span> Beschikbare plaatsen <span class="info">{{hasGuestlistForced() ? 0 : event?.maxAttendees - event?.numberOfAttendees}}</span>
          </div>
        </div>
        <div class="register" *ngIf="showRegisterForm && event.startDateTime">
          <h1>Gegevens</h1>
          <div class="normal-text">
            Vul je gegevens in en meld je aan. Zo kunnen we je op de hoogte houden van dit event.
            Wil je ook een collega aanmelden? Meld je dan eerst zelf aan.
          </div>
          <form [formGroup]="form">
            <div>
              <app-input label="Bedrijfsnaam (verplicht)" formControlName="companyName"></app-input>
              <app-input label="Voor- en achternaam (verplicht)" formControlName="name"></app-input>
            </div>
            <div>
              <app-input label="Debiteurnumer (verplicht)" formControlName="debitNo"></app-input>
              <app-input label="E-mailadres (verplicht)" formControlName="email"></app-input>
            </div>
            <div>
              <app-input label="Plaats (verplicht)" formControlName="city"></app-input>
              <app-input label="Telefoonnummer (verplicht)" formControlName="phoneNumber"></app-input>
            </div>
            <div *ngIf="item?.multipleChoice?.title?.length > 0">
              <app-select label="{{item.multipleChoice.title}} (verplicht)" [options]="getMultipleChoiceOptions(item.multipleChoice.options)" formControlName="multipleChoice" (optionChange)="form.get('multipleChoice').setValue($event)"></app-select>
              <div>&nbsp;</div>
            </div>
            <div class="submit-button">
              <div>&nbsp;</div>
              <app-button (click)="register(form.value)" *ngIf="!isFull()" [disabled]="!form.valid || disableButton">Meld mij aan</app-button>
              <app-button (click)="register(form.value)" *ngIf="isFull()" [disabled]="!form.valid || disableButton">Zet me op wachtlijst</app-button>
            </div>
            <app-feedback [type]="MessageType.ERROR" *ngIf="registrationError">{{registrationError}}</app-feedback>
          </form>
        </div>

        <div class="half-width">
          <div class="green-background" *ngIf="registerSuccess">
            <h1>Leuk dat je je hebt aangemeld</h1>
            We sturen je een e-mail ter bevestiging
          </div>
          <div class="green-background" *ngIf="registerColleagueSuccess">
            <h1>Leuk dat je je collega hebt aangemeld</h1>
            We sturen je collega een email ter bevestiging.
          </div>
          <div class="register" *ngIf="!showRegisterForm">
            <h1>Collega aanmelden</h1>
            <div class="normal-text">
              Wil je samen met een collega naar dit event en hem/haar ook aanmelden?
              Vul dan ook zijn/haar gegevens in.
            </div>
            <div class="small-text">Voor dit event kun je maximaal {{event?.maxInvitees}} collega’s aanmelden.</div>
            <form [formGroup]="formColleague" class="register-colleague">
              <div>
                <app-input label="Voor- en achternaam (verplicht)" formControlName="name"></app-input>
              </div>
              <div *ngIf="item?.multipleChoice?.title?.length > 0">
                <app-select label="{{item.multipleChoice.title}} (verplicht)" [options]="getMultipleChoiceOptions(item.multipleChoice.options)" formControlName="multipleChoice" (optionChange)="formColleague.get('multipleChoice').setValue($event)"></app-select>
              </div>
              <div>
                <app-input label="E-mailadres" formControlName="email"></app-input>
              </div>
              <div>
                <app-input label="Telefoonnummer" formControlName="phoneNumber"></app-input>
              </div>
              <span class="event-full" *ngIf="isEventFull">Helaas zit dit event vol</span>
              <div>
                <app-button (click)="registerColleague(formColleague.value)" *ngIf="!isFullOrRegisteredMaxInvitees()" [disabled]="!formColleague.valid  || disableButton">Meld collega aan</app-button>
                <app-button (click)="registerColleague(formColleague.value)" *ngIf="isFullOrRegisteredMaxInvitees() &&  event.maxInvitees !== colleagueRegistrationCounter" [disabled]="!formColleague.valid  || disableButton">Collega inschrijven op wachtlijst</app-button>
                <p *ngIf="event.maxInvitees === colleagueRegistrationCounter">Gelukt! Je hebt het maximaal aantal collega's uitgenodigd!</p>
              </div>
            </form>
          </div>
        </div>
        <app-feedback [type]="MessageType.ERROR" *ngIf="registrationColleagueError">{{registrationColleagueError}}</app-feedback>
      </section>
    </aside>
  </div>
</main>
<app-footer
  [showAllEventsButton]="true"
  [contactStyle]="ContactStyle.DETAIL"
  [showInviteColleague]="true"
  [itemId]="itemId"
  [valueMap]="valueMap"
  *ngIf="event && loadingEvent === false"
></app-footer>
